export const UserMappedErrorMsg =
  'OOPS! Some Users are mapped to it. Remove the user mappings to delete the mapping';
